import type { IconSvgObject } from './types';

const LaptopRemoveIcon: IconSvgObject = [
  ["path", { d: "M22.5 20.5H1.5L3.5 16.5H20.5L22.5 20.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20.5 16.5V5C20.5 4.17157 19.8284 3.5 19 3.5H5C4.17157 3.5 3.5 4.17157 3.5 5V16.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M10 8L12 10M12 10L14 12M12 10L14 8M12 10L10 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default LaptopRemoveIcon;
